import React from 'react'

const ArrowLeft = () => (
  <svg viewBox="0 0 15 25" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.895 11.404L15 0h-2.86L0 12.5 12.14 25H15L3.895 13.596z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
)

export default ArrowLeft
